import { SimpleModal, Box } from '@sequencehq/core-components'
import { FC } from 'react'
import { useUnlinkSalesforceOpportunityModal } from './useUnlinkSalesforceOpportunityModal'
import { GreyGrey80, Primary13Regular } from '@sequencehq/core-components'

type Props = {
  onUnlink: () => void
  onClose: () => void
}

export const UnlinkSalesforceOpportunityModal: FC<Props> = props => {
  const hook = useUnlinkSalesforceOpportunityModal({
    onConfirm: props.onUnlink
  })

  return (
    <SimpleModal
      isOpen
      variant="dialog"
      onClose={props.onClose}
      data-testid="salesforce.opportunity.unlink.modal"
      title="Unlink this quote from Salesforce"
      isDestructive
      disableSubmitOnEnter
      submitButtonText="Unlink"
      cancelButtonText="Cancel"
      onSubmit={hook.submit.onClick}
    >
      <Box color={GreyGrey80} {...Primary13Regular} flex={1}>
        This will unlink the customer from Salesforce immediately. You can
        re-link the customer again if required.
      </Box>
    </SimpleModal>
  )
}
